var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.79863 0.191443C5.55098 -0.0638164 5.14945 -0.063814 4.9018 0.191448L1.17011 4.03782C0.922462 4.29308 0.922463 4.70694 1.17011 4.9622L4.9018 8.80855C5.14946 9.06381 5.55098 9.06382 5.79863 8.80856C6.04629 8.5533 6.04629 8.13944 5.79864 7.88417L2.51536 4.50001L5.79864 1.11582C6.04629 0.860562 6.04629 0.446702 5.79863 0.191443Z","fill":"#011B33"}));
}

BackArrow.defaultProps = {"width":"6","height":"11","viewBox":"0 0 6 11","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
